import {Box, VStack} from 'platform/foundation';
import {match} from 'ts-pattern';

import {isNotEmpty} from 'ramda';
import {isNotString} from 'ramda-adjunct';

import {businessCaseRoutes, testIds} from '@dms/routes';
import {catchUnhandledDataGridActions, DmsDataGrid, queryParams} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const EXTERNAL_FILTER_ID = 'complaintsFilter';

const PREDEFINED_COLUMNS = ['businessCase'] as const;

export function BusinessCaseComplaintsList() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    rowId,
    getColumnData,
  }) => {
    if (isNotString(rowId)) {
      return;
    }

    const businessCaseId = getColumnData<{id: string}>('businessCase')?.value?.id;

    if (isNotString(businessCaseId) || !isNotEmpty(businessCaseId)) {
      return;
    }

    const path = composePath(
      `${businessCaseRoutes.complaints}?${queryParams.REDIRECT_SOURCE}=business-case-complaints-list` as typeof businessCaseRoutes.complaints,
      {
        params: {id: businessCaseId},
        isSearchParamsPreserved: false,
      }
    );

    match(actionKey)
      .with('complaintDetail', () => navigate(path))
      .with('complaintDetail_newTab', () => window.open(path))
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <VStack spacing={4} height="100%">
      <Box>
        <div id={EXTERNAL_FILTER_ID} />
      </Box>
      <Box height="100%">
        <DmsDataGrid
          gridCode="complaint"
          actionCallback={actionCallback}
          predefinedColumns={PREDEFINED_COLUMNS}
          externalFilterId={EXTERNAL_FILTER_ID}
          data-testid={testIds.businessCase.home('businessCaseComplaintsList')}
        />
      </Box>
    </VStack>
  );
}
